import {
  CheckCircleIcon,
  TimeIcon,
  WarningIcon,
  CloseIcon,
  InfoIcon,
} from "@chakra-ui/icons";

export const PROJECT_STATUS_CONFIG = {
  Open: {
    color: "green",
    icon: TimeIcon,
  },

  "Agenda Item For Next Meeting": {
    color: "blue",
    icon: InfoIcon,
  },

  "Consultor’s Approved": {
    color: "orange",
    icon: CheckCircleIcon,
  },

  "Consultor’s Denied": {
    color: "red",
    icon: CloseIcon,
  },

  "Administratively Approved": {
    color: "purple",
    icon: CheckCircleIcon,
  },

  Closed: {
    color: "gray",
    icon: WarningIcon,
  },

  Other: {
    color: "gray",
    icon: InfoIcon,
  },
};

export const DEFAULT_PROJECT_STATUS_CONFIG = {
  color: "gray",
  icon: InfoIcon,
};